import { CategoryFolderEnum } from '@shared/enums/categorie.enum';
import { OrderByEnum } from '@shared/models/common/orderby.enum';
import { RechercheColonneEnum } from '@shared/enums/recherche-colonne.enum';
export class RechercheForm {
  constructor(
    public typeDispositif?: string,
    public typeDispositifLibelle?: string,
    public numDossier?: string,
    public dateDebut?: Date,
    public dateFin?: Date,
    public dateDecision?: Date,
    public nomStagiaire?: string,
    public prenomStagiaire?: string,
    public rechercheBySiret: boolean = false,
    public siret?: string,
    public statut?: string,
    public statutLabel?: string,
    public decision: string = '=',
    public decisionLabel: string = 'est égale',
    public solder: boolean = false,
    public paiementOrganismeLabel: boolean | string = '',
    public paiementOrganisme?: boolean,
    public categorieDossier: CategoryFolderEnum = CategoryFolderEnum.TOUTES,
    public page: number = 0,
    public nbElement?: number,

    public orderBy?: OrderByEnum,
    public orderByColumn?: RechercheColonneEnum
  ) {}
}
